import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as _ from 'underscore';

import {FinancePlanRowContainer} from './blocks/FinancePlanRow';

import RhinoLoading from '../common/RhinoLoading';

import * as financeActionCreators from '../../../actions/finance';
let allActionCreators = Object.assign({}, financeActionCreators);


class FinancePlans extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      requestPending: true,
      requestPlans: [],

      addNewPlan: false,

      width: window.innerWidth,
    };

    this.controller = null;

    this.checkWidthThrottled = _.throttle(this.checkWidth.bind(this), 50);
  }

  componentDidMount() {
    this.fetchPlans();
    window.addEventListener('resize', this.checkWidthThrottled, false);
  }

  componentWillUnmount() {
    if(this.controller) {
      this.controller.abort();
    }
    window.removeEventListener('resize', this.checkWidthThrottled, false);
  }

  checkWidth() {
    this.setState({ width: window.innerWidth });
  }

  async fetchPlans() {

    if(this.controller) {
      this.controller.abort();
    }
    const controller = new AbortController();
    this.controller = controller;

    this.setState({
      requestPending: true,
      requestPlans: [],
    });

    const plansResp = await this.props.financeFetchPlans(controller.signal)
      .catch((errResp) => {
        
        if(controller.signal.aborted) { return null; }

        console.error(errResp);
        this.setState({ 
          requestPending: false,
          responseObject: [],
        });
      });

    if(!plansResp) { return null; }

    this.setState({
      requestPending: false,
      requestPlans: plansResp || [],
    });
  }

  openAdd() {
    this.setState({ addNewPlan: true });
  }

  closeAdd() {
    this.setState({ addNewPlan: false });
  }
    
  render() {
    return <div className='FinancePlans'>
      <div className='plansWrapper'>
        <div className='plansTitle'>Manage Finance Plans</div>
        {this.state.requestPending ?
          <div className='planLoadingWrapper'>
            <RhinoLoading message='Loading financing plans' />
          </div> :
          <div className='plansTableWrapper'>
            <div className='plansTable'>
              <div className='tableHeaderWrapper'>
                <div className='tableHeader'>
                  <div className={'idCell headerCell'}>
                    <div className='headerValue'>Id</div>
                  </div>
                  <div className={'termCell headerCell'}>
                    <div className='headerValue'>Term</div>
                  </div>
                  <div className={'aprCell headerCell'}>
                    <div className='headerValue'>APR</div>
                  </div>
                  <div className={'costCell headerCell'}>
                    <div className='headerValue'>Cost</div>
                  </div>
                  <div className={'actionCell headerCell'}></div>
                </div>
              </div>
              <div className='tableBodyWrapper'>
                {this.state.requestPlans.length === 0 && !this.state.addNewPlan ?
                  <div className='nullResults'>
                    <div className='nullMessage'>No financing plans found</div>
                  </div> :
                  <div className='tableBody'>
                    {this.state.requestPlans.map((plan, i) => {
                      return <div key={i} className='tableRowWrapper'>
                        <FinancePlanRowContainer 
                          plan={plan}
                          makeClean={this.fetchPlans.bind(this)}
                          width={this.state.width} />
                      </div>
                    })}
                    {this.state.addNewPlan ?
                      <div className='tableRowWrapper'>
                        <FinancePlanRowContainer 
                          plan={null}
                          makeClean={this.fetchPlans.bind(this)}
                          parentClose={this.closeAdd.bind(this)}
                          width={this.state.width} />
                      </div> :
                      null
                    }
                  </div>
                }
              </div>
            </div>
            <div className='plansAddWrapper'>
              {!this.state.addNewPlan ?
                <div className='actionWrapper'>
                  <button type='button' className='actionButton' onClick={this.openAdd.bind(this)}>+ Plan</button>
                </div> :
                null
              }
            </div>
          </div>
        }
      </div>
    </div>;
  }
}
export default FinancePlans;

function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

export const FinancePlansContainer = connect(
  mapStateToProps,
  allActionCreators
)(FinancePlans);